export default __webpack_public_path__ + "static/media/gallery_07.72f4fe87.jpg";